import { initAuthCore } from './services/authCore'
import React, { useEffect } from 'react'
import { AppProps as SingleSpaAppProps } from 'single-spa'
import { RemoteConfigProvider } from './modules/RemoteConfig'
import { useRemoteConfig } from './modules/RemoteConfig/hooks/useRemoteConfig'

export type AppProps = SingleSpaAppProps & {
    homeProps?: {
        basename: string
    }
}

const Global = () => {
    const { isFeatureEnabled } = useRemoteConfig()

    const isEnabled = isFeatureEnabled('ENABLED_NAV_GLOBAL_TOKEN_INTERCEPTOR')

    useEffect(() => {
        if (isEnabled) {
            initAuthCore()
        }
    }, [isEnabled])

    return <></>
}

const App = () => {
    return (
        <RemoteConfigProvider>
            <Global />
        </RemoteConfigProvider>
    )
}

export default App
